import { useQuery } from "@tanstack/react-query";
import { getPaxTypesForSelect } from "../../api/apiPaxTypes";
import i18next from "i18next";

const useGetPaxTypesForSelect = () => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["PaxTypes-for-select", i18next.language],
        queryFn: getPaxTypesForSelect,
    });

    return {
        options: data?.data || [],
        error,
        isLoading,
    };
};

export default useGetPaxTypesForSelect;
